import React__default from 'react';
import { Platform, View, StyleSheet } from 'react-native';
import { DataTable } from 'react-native-paper';
import { A as AppAssets } from '../../dist/index-3256db5b.esm.js';
import { u as useTheme } from '../../dist/useTheme-90e8e2c2.esm.js';
import { A as AppText, a as AppIcon } from '../../dist/index-6b88191c.esm.js';
import { A as AppButtonMenu } from '../../dist/index-8ad68543.esm.js';
import '@fortawesome/pro-light-svg-icons/faAdjust';
import '@fortawesome/pro-light-svg-icons/faAlignCenter';
import '@fortawesome/pro-light-svg-icons/faAlignLeft';
import '@fortawesome/pro-light-svg-icons/faAlignRight';
import '@fortawesome/pro-light-svg-icons/faArrowCircleRight';
import '@fortawesome/pro-light-svg-icons/faArrowSquareLeft';
import '@fortawesome/pro-light-svg-icons/faArrowToRight';
import '@fortawesome/pro-light-svg-icons/faBan';
import '@fortawesome/pro-light-svg-icons/faBars';
import '@fortawesome/pro-light-svg-icons/faBell';
import '@fortawesome/pro-light-svg-icons/faBezierCurve';
import '@fortawesome/pro-light-svg-icons/faBold';
import '@fortawesome/pro-light-svg-icons/faBookOpen';
import '@fortawesome/pro-light-svg-icons/faBookReader';
import '@fortawesome/pro-light-svg-icons/faBookmark';
import '@fortawesome/pro-light-svg-icons/faBooks';
import '@fortawesome/pro-light-svg-icons/faBracketsCurly';
import '@fortawesome/pro-light-svg-icons/faBrain';
import '@fortawesome/pro-light-svg-icons/faHeadSideBrain';
import '@fortawesome/pro-light-svg-icons/faBrowser';
import '@fortawesome/pro-light-svg-icons/faCalendarDay';
import '@fortawesome/pro-light-svg-icons/faCalendarEdit';
import '@fortawesome/pro-light-svg-icons/faFileChartLine';
import '@fortawesome/pro-light-svg-icons/faChartColumn';
import '@fortawesome/pro-light-svg-icons/faChartNetwork';
import '@fortawesome/pro-light-svg-icons/faCheckCircle';
import '@fortawesome/pro-light-svg-icons/faChevronDoubleUp';
import '@fortawesome/pro-light-svg-icons/faChevronDown';
import '@fortawesome/pro-light-svg-icons/faChevronLeft';
import '@fortawesome/pro-light-svg-icons/faScannerTouchscreen';
import '@fortawesome/pro-light-svg-icons/faChevronRight';
import '@fortawesome/pro-light-svg-icons/faChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircle';
import '@fortawesome/pro-light-svg-icons/faClipboard';
import '@fortawesome/pro-light-svg-icons/faClipboardListCheck';
import '@fortawesome/pro-light-svg-icons/faSparkles';
import '@fortawesome/pro-light-svg-icons/faClock';
import '@fortawesome/pro-light-svg-icons/faClone';
import '@fortawesome/pro-light-svg-icons/faCloudDownload';
import '@fortawesome/pro-light-svg-icons/faCloudUpload';
import '@fortawesome/pro-light-svg-icons/faCode';
import '@fortawesome/pro-light-svg-icons/faCodeMerge';
import '@fortawesome/pro-light-svg-icons/faCog';
import '@fortawesome/pro-light-svg-icons/faCommentAltLines';
import '@fortawesome/pro-light-svg-icons/faCommentLines';
import '@fortawesome/pro-light-svg-icons/faCommentsAlt';
import '@fortawesome/pro-light-svg-icons/faCompressAlt';
import '@fortawesome/pro-light-svg-icons/faCopy';
import '@fortawesome/pro-light-svg-icons/faCreditCard';
import '@fortawesome/pro-light-svg-icons/faDatabase';
import '@fortawesome/pro-light-svg-icons/faDollarSign';
import '@fortawesome/pro-light-svg-icons/faEdit';
import '@fortawesome/pro-light-svg-icons/faEllipsisH';
import '@fortawesome/pro-light-svg-icons/faEllipsisV';
import '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';
import '@fortawesome/pro-light-svg-icons/faEraser';
import '@fortawesome/pro-light-svg-icons/faExchangeAlt';
import '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import '@fortawesome/pro-light-svg-icons/faExpandAlt';
import '@fortawesome/pro-light-svg-icons/faExpandWide';
import '@fortawesome/pro-light-svg-icons/faEye';
import '@fortawesome/pro-light-svg-icons/faEyeSlash';
import '@fortawesome/pro-light-svg-icons/faFile';
import '@fortawesome/pro-light-svg-icons/faFileAlt';
import '@fortawesome/pro-light-svg-icons/faFileCode';
import '@fortawesome/pro-light-svg-icons/faFileCsv';
import '@fortawesome/pro-light-svg-icons/faFileExcel';
import '@fortawesome/pro-light-svg-icons/faFileExport';
import '@fortawesome/pro-light-svg-icons/faFileImport';
import '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar';
import '@fortawesome/pro-light-svg-icons/faFilePdf';
import '@fortawesome/pro-light-svg-icons/faFilePowerpoint';
import '@fortawesome/pro-light-svg-icons/faFileSignature';
import '@fortawesome/pro-light-svg-icons/faFileUpload';
import '@fortawesome/pro-light-svg-icons/faFileWord';
import '@fortawesome/pro-light-svg-icons/faFolder';
import '@fortawesome/pro-light-svg-icons/faFont';
import '@fortawesome/pro-light-svg-icons/faGameBoardAlt';
import '@fortawesome/pro-light-svg-icons/faGlobeEurope';
import '@fortawesome/pro-light-svg-icons/faGlobePointer';
import '@fortawesome/pro-light-svg-icons/faGripLinesVertical';
import '@fortawesome/pro-light-svg-icons/faGripVertical';
import '@fortawesome/pro-light-svg-icons/faH1';
import '@fortawesome/pro-light-svg-icons/faH2';
import '@fortawesome/pro-light-svg-icons/faHashtag';
import '@fortawesome/pro-light-svg-icons/faHighlighter';
import '@fortawesome/pro-light-svg-icons/faHistory';
import '@fortawesome/pro-light-svg-icons/faHomeAlt';
import '@fortawesome/pro-light-svg-icons/faImage';
import '@fortawesome/pro-light-svg-icons/faInbox';
import '@fortawesome/pro-light-svg-icons/faIndent';
import '@fortawesome/pro-light-svg-icons/faInfoCircle';
import '@fortawesome/pro-light-svg-icons/faItalic';
import '@fortawesome/pro-light-svg-icons/faKeyboard';
import '@fortawesome/pro-light-svg-icons/faLanguage';
import '@fortawesome/pro-light-svg-icons/faLaptopCode';
import '@fortawesome/pro-light-svg-icons/faLayerGroup';
import '@fortawesome/pro-light-svg-icons/faLightbulbExclamation';
import '@fortawesome/pro-light-svg-icons/faLink';
import '@fortawesome/pro-light-svg-icons/faListOl';
import '@fortawesome/pro-light-svg-icons/faListUl';
import '@fortawesome/pro-light-svg-icons/faLock';
import '@fortawesome/pro-light-svg-icons/faLockOpen';
import '@fortawesome/pro-light-svg-icons/faMeteor';
import '@fortawesome/pro-light-svg-icons/faMicrophone';
import '@fortawesome/pro-light-svg-icons/faMoneyCheckAlt';
import '@fortawesome/pro-light-svg-icons/faNetworkWired';
import '@fortawesome/pro-light-svg-icons/faPaintRoller';
import '@fortawesome/pro-light-svg-icons/faPaperPlaneTop';
import '@fortawesome/pro-light-svg-icons/faPen';
import '@fortawesome/pro-light-svg-icons/faPlanetRinged';
import '@fortawesome/pro-light-svg-icons/faPlus';
import '@fortawesome/pro-light-svg-icons/faPlusCircle';
import '@fortawesome/pro-light-svg-icons/faPowerOff';
import '@fortawesome/pro-light-svg-icons/faQuestion';
import '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import '@fortawesome/pro-light-svg-icons/faQuoteLeft';
import '@fortawesome/pro-light-svg-icons/faRedo';
import '@fortawesome/pro-light-svg-icons/faReply';
import '@fortawesome/pro-light-svg-icons/faRocketLaunch';
import '@fortawesome/pro-light-svg-icons/faSatelliteDish';
import '@fortawesome/pro-light-svg-icons/faScrubber';
import '@fortawesome/pro-light-svg-icons/faSearch';
import '@fortawesome/pro-light-svg-icons/faSearchMinus';
import '@fortawesome/pro-light-svg-icons/faSearchPlus';
import '@fortawesome/pro-light-svg-icons/faShareAlt';
import '@fortawesome/pro-light-svg-icons/faSignOut';
import '@fortawesome/pro-light-svg-icons/faSlidersV';
import '@fortawesome/pro-light-svg-icons/faSlidersVSquare';
import '@fortawesome/pro-light-svg-icons/faSpinner';
import '@fortawesome/pro-light-svg-icons/faStopCircle';
import '@fortawesome/pro-light-svg-icons/faStream';
import '@fortawesome/pro-light-svg-icons/faStrikethrough';
import '@fortawesome/pro-light-svg-icons/faSync';
import '@fortawesome/pro-light-svg-icons/faTag';
import '@fortawesome/pro-light-svg-icons/faTerminal';
import '@fortawesome/pro-light-svg-icons/faThumbsDown';
import '@fortawesome/pro-light-svg-icons/faThumbsUp';
import '@fortawesome/pro-light-svg-icons/faThumbtack';
import '@fortawesome/pro-light-svg-icons/faTimes';
import '@fortawesome/pro-light-svg-icons/faTimesCircle';
import '@fortawesome/pro-light-svg-icons/faTrash';
import '@fortawesome/pro-light-svg-icons/faTypewriter';
import '@fortawesome/pro-light-svg-icons/faUnderline';
import '@fortawesome/pro-light-svg-icons/faUndo';
import '@fortawesome/pro-light-svg-icons/faUnlink';
import '@fortawesome/pro-light-svg-icons/faUser';
import '@fortawesome/pro-light-svg-icons/faUserCircle';
import '@fortawesome/pro-light-svg-icons/faUserLock';
import '@fortawesome/pro-light-svg-icons/faUserBeardBolt';
import '@fortawesome/pro-light-svg-icons/faUserRobot';
import '@fortawesome/pro-light-svg-icons/faUserSecret';
import '@fortawesome/pro-light-svg-icons/faUserAstronaut';
import '@fortawesome/pro-light-svg-icons/faUserShield';
import '@fortawesome/pro-light-svg-icons/faUsers';
import '@fortawesome/pro-light-svg-icons/faUsersCog';
import '@fortawesome/pro-light-svg-icons/faVial';
import '@fortawesome/pro-light-svg-icons/faWaveSquare';
import '@fortawesome/pro-light-svg-icons/faWifiSlash';
import '@fortawesome/pro-light-svg-icons/faWindowMinimize';
import '@fortawesome/pro-light-svg-icons/faChartBar';
import '@fortawesome/pro-light-svg-icons/faSlidersH';
import '@fortawesome/pro-light-svg-icons/faPageBreak';
import '@fortawesome/pro-light-svg-icons/faServer';
import '@fortawesome/pro-light-svg-icons/faTools';
import '@fortawesome/pro-light-svg-icons/faAnalytics';
import '@fortawesome/pro-light-svg-icons/faTrophy';
import '@fortawesome/pro-light-svg-icons/faDice';
import '@fortawesome/pro-light-svg-icons/faSwords';
import '@fortawesome/pro-light-svg-icons/faBoxingGlove';
import '@fortawesome/pro-light-svg-icons/faRandom';
import '@fortawesome/pro-light-svg-icons/faVideoPlus';
import '@fortawesome/pro-light-svg-icons/faFileAudio';
import '@fortawesome/pro-light-svg-icons/faMagic';
import '@fortawesome/pro-light-svg-icons/faSitemap';
import '@fortawesome/pro-light-svg-icons/faFiles';
import '@fortawesome/pro-light-svg-icons/faUserShakespeare';
import '@fortawesome/pro-light-svg-icons/faUserPilot';
import '@fortawesome/pro-light-svg-icons/faUserPilotTie';
import '@fortawesome/pro-light-svg-icons/faUserRobotXmarks';
import '@fortawesome/pro-light-svg-icons/faUserVisor';
import '@fortawesome/pro-light-svg-icons/faUserNinja';
import '@fortawesome/pro-light-svg-icons/faUserGear';
import '@fortawesome/pro-light-svg-icons/faArrowTurnDownRight';
import '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import '@fortawesome/pro-light-svg-icons/faMessageBot';
import '@fortawesome/pro-light-svg-icons/faVolume';
import '@fortawesome/pro-light-svg-icons/faVolumeSlash';
import '@fortawesome/pro-light-svg-icons/faImages';
import '@fortawesome/pro-light-svg-icons/faSwordLaser';
import '@fortawesome/pro-light-svg-icons/faSwordsLaser';
import '@fortawesome/pro-light-svg-icons/faHelmetBattle';
import '@fortawesome/pro-light-svg-icons/faUpRightAndDownLeftFromCenter';
import '@fortawesome/pro-light-svg-icons/faDownLeftAndUpRightToCenter';
import '@fortawesome/pro-light-svg-icons/faFileSpreadsheet';
import '@fortawesome/pro-light-svg-icons/faPresentationScreen';
import '@fortawesome/pro-light-svg-icons/faFileInvoice';
import '@fortawesome/pro-light-svg-icons/faChalkboardTeacher';
import '@fortawesome/pro-light-svg-icons/faCircleDollar';
import '@fortawesome/pro-light-svg-icons/faPersonFairy';
import '@fortawesome/pro-light-svg-icons/faCubes';
import '@fortawesome/pro-light-svg-icons/faUserHeadset';
import '@fortawesome/pro-light-svg-icons/faPalette';
import '@fortawesome/pro-light-svg-icons/faChartMixed';
import '@fortawesome/pro-light-svg-icons/faBrainCircuit';
import '@fortawesome/pro-light-svg-icons/faImageLandscape';
import '@fortawesome/pro-light-svg-icons/faHexagonPlus';
import '@fortawesome/pro-light-svg-icons/faPrintMagnifyingGlass';
import '@fortawesome/pro-light-svg-icons/faShieldHalved';
import '@fortawesome/pro-light-svg-icons/faDiagramSubtask';
import '@fortawesome/pro-light-svg-icons/faHandshake';
import '@fortawesome/pro-light-svg-icons/faBullhorn';
import '@fortawesome/pro-light-svg-icons/faCogs';
import '@fortawesome/pro-light-svg-icons/faHeadset';
import '@fortawesome/pro-light-svg-icons/faMicroscope';
import '@fortawesome/pro-light-svg-icons/faScaleBalanced';
import '@fortawesome/pro-light-svg-icons/faTruck';
import '@fortawesome/pro-light-svg-icons/faBuildings';
import '@fortawesome/pro-light-svg-icons/faInputText';
import '@fortawesome/pro-light-svg-icons/faProjectDiagram';
import '@fortawesome/pro-light-svg-icons/faPaperclip';
import '@fortawesome/pro-light-svg-icons/faFileVideo';
import '@fortawesome/pro-light-svg-icons/faCircleChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircleChevronDown';
import '@fortawesome/pro-light-svg-icons/faUnlockKeyhole';
import '@fortawesome/pro-light-svg-icons/faChartScatter3d';
import '@fortawesome/pro-light-svg-icons/faSidebar';
import '@fortawesome/pro-light-svg-icons/faGlobe';
import '@fortawesome/pro-light-svg-icons/faSquare';
import '@fortawesome/pro-light-svg-icons/faSquareRss';
import '@fortawesome/pro-light-svg-icons/faAsterisk';
import '@fortawesome/pro-light-svg-icons/faCircleUser';
import '@fortawesome/pro-light-svg-icons/faUpFromBracket';
import '@fortawesome/pro-light-svg-icons/faHouseLock';
import '@fortawesome/pro-light-svg-icons/faXmarkToSlot';
import '@fortawesome/pro-light-svg-icons/faRobot';
import '@fortawesome/pro-light-svg-icons/faMagicWandSparkles';
import '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import '@fortawesome/pro-light-svg-icons/faBook';
import '@fortawesome/pro-light-svg-icons/faImagePolaroid';
import '@fortawesome/pro-light-svg-icons/faVideo';
import '@fortawesome/pro-light-svg-icons/faCube';
import '@fortawesome/pro-light-svg-icons/faToolbox';
import '@fortawesome/pro-light-svg-icons/faTimer';
import '@fortawesome/pro-light-svg-icons/faThoughtBubble';
import '@fortawesome/pro-light-svg-icons/faSwap';
import '@fortawesome/pro-light-svg-icons/faFloppyDisk';
import '@fortawesome/pro-light-svg-icons/faWandMagicSparkles';
import '@fortawesome/pro-light-svg-icons/faXmark';
import '@fortawesome/pro-light-svg-icons/faFileVector';
import '@fortawesome/pro-light-svg-icons/faWrench';
import '@fortawesome/pro-light-svg-icons/faVectorPolygon';
import '@fortawesome/pro-light-svg-icons/faClose';
import '@fortawesome/pro-light-svg-icons/faCircleXmark';
import '@fortawesome/pro-light-svg-icons/faCloud';
import '@fortawesome/pro-light-svg-icons/faPlanetMoon';
import '@fortawesome/pro-light-svg-icons/faListCheck';
import '@fortawesome/pro-light-svg-icons/faUnlock';
import '@fortawesome/pro-light-svg-icons/faCheck';
import '@fortawesome/pro-light-svg-icons/faCirclePlus';
import '@fortawesome/pro-light-svg-icons/faCircleMinus';
import '@fortawesome/pro-light-svg-icons/faWandSparkles';
import '@fortawesome/pro-light-svg-icons/faHardDrive';
import '@fortawesome/pro-light-svg-icons/faLightbulb';
import '../../dist/extends-a2cb9f0c.esm.js';
import 'react-i18next';
import '../../dist/index-0ee62650.esm.js';
import '@fortawesome/react-native-fontawesome';
import 'react-native-popable';
import 'markdown-it';
import 'mermaid';
import 'url';
import 'highlight.js';
import '@mermaid-js/mermaid-zenuml/dist/mermaid-zenuml.core.mjs';
import 'lodash-es';
import 'react-native-markdown-display';

const AppTableRow = _ref => {
  var _headers, _headers2, _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _headers3, _headers4, _currentTheme$theme6, _currentTheme$theme7, _headers5, _headers6, _currentTheme$theme8, _currentTheme$theme9, _headers7, _headers8, _currentTheme$theme10, _currentTheme$theme11;
  let {
    item,
    index,
    _styles,
    fontStyle,
    headers,
    actionButtons,
    handleDocumentAction,
    handleDocumentSelection,
    handleDocumentDeletion,
    customEditIcon,
    customDeleteIcon,
    customActionIcon,
    actions,
    showDropDownMenuForActions,
    onActionItemPress,
    isItemDeletable,
    isItemEditable,
    isItemActionable,
    mapIconWithStatus,
    mapSelectionIconWithStatus,
    marginRightBeforeActions,
    currentTheme,
    mainActionLabel,
    actionButtonStyle,
    actionButtonMenuItemStyle,
    actionButtonWrapperStyles,
    onClickMainAction,
    ...props
  } = _ref;
  const [isActionOpened, setIsActionOpened] = React__default.useState(false);
  return /*#__PURE__*/React__default.createElement(DataTable.Row, {
    key: index,
    style: {
      ..._styles.row,
      zIndex: isActionOpened ? 1 : -1
    },
    theme: fontStyle,
    pointerEvents: "auto",
    focusable: true
  }, Object.entries(item).map((kV, index) => {
    var _headers$index, _headers$index2, _Object$entries, _Object$entries2;
    return /*#__PURE__*/React__default.createElement(DataTable.Cell, {
      key: index,
      theme: fontStyle,
      style: [_styles.cell, {
        flex: headers && (_headers$index = headers[index]) !== null && _headers$index !== void 0 && _headers$index.width ? (_headers$index2 = headers[index]) === null || _headers$index2 === void 0 ? void 0 : _headers$index2.width : 1,
        flexBasis: 70,
        marginRight: index === ((_Object$entries = Object.entries(item)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.length) - 2 && actionButtons ? marginRightBeforeActions : 0,
        position: index === ((_Object$entries2 = Object.entries(item)) === null || _Object$entries2 === void 0 ? void 0 : _Object$entries2.length) - 1 && actionButtons ? "absolute" : "unset"
      }]
    }, /*#__PURE__*/React__default.createElement(AppText, {
      wrapperStyle: {
        textOverflow: Platform.OS === "web" && "ellipsis",
        overflow: "hidden",
        whiteSpace: Platform.OS === "web" && "nowrap",
        width: Platform.OS === "web" && "-webkit-fill-available",
        paddingHorizontal: 5
      },
      style: {
        textOverflow: Platform.OS === "web" && "ellipsis",
        overflow: "hidden",
        whiteSpace: Platform.OS === "web" && "nowrap",
        width: Platform.OS === "web" && "-webkit-fill-available"
      }
    }, " ", kV[1]));
  }), showDropDownMenuForActions ? /*#__PURE__*/React__default.createElement(View, {
    style: [_styles.actionsCell, {
      flex: headers && (_headers = headers[(headers === null || headers === void 0 ? void 0 : headers.length) - 1]) !== null && _headers !== void 0 && _headers.width ? (_headers2 = headers[(headers === null || headers === void 0 ? void 0 : headers.length) - 1]) === null || _headers2 === void 0 ? void 0 : _headers2.width : 1,
      flexBasis: 90,
      justifyContent: "center",
      position: "absolute",
      right: -15,
      top: 6
    }]
  }, /*#__PURE__*/React__default.createElement(AppButtonMenu, {
    mainActionLabel: mainActionLabel,
    wrapperStyle: [{
      paddingVertical: 10,
      paddingHorizontal: 10,
      borderRadius: 10
    }, actionButtonWrapperStyles],
    labelStyle: {
      fontWeight: "bold"
    },
    style: [{
      top: 35,
      fontWeight: "bold",
      minWidth: 20,
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.small_font_size,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.font_color,
      textAlign: "-webkit-center",
      fontSize: 12,
      left: -20
    }, actionButtonStyle],
    chevronColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.font_color,
    chevronSize: 12,
    menuItemStyle: [{
      marginLeft: 10,
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.extra_small_font_size
    }, actionButtonMenuItemStyle],
    color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.font_color,
    menuItemIconSize: 14,
    onClickMenuItem: id => {
      onActionItemPress(id, item, index);
    },
    onMenuOpened: () => {
      setIsActionOpened(true);
    },
    onMenuClosed: () => {
      setIsActionOpened(false);
    },
    options: actions,
    onClickMainAction: () => {
      onClickMainAction(item, index);
    }
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, actionButtons && handleDocumentAction && /*#__PURE__*/React__default.createElement(DataTable.Cell, {
    onPress: event => {
      handleDocumentAction({
        id: item === null || item === void 0 ? void 0 : item.id,
        type: item === null || item === void 0 ? void 0 : item.type,
        item,
        index
      });
    },
    style: [_styles.actionsCell, {
      flex: headers && (_headers3 = headers[(headers === null || headers === void 0 ? void 0 : headers.length) - 1]) !== null && _headers3 !== void 0 && _headers3.width ? (_headers4 = headers[(headers === null || headers === void 0 ? void 0 : headers.length) - 1]) === null || _headers4 === void 0 ? void 0 : _headers4.width : 1,
      flexBasis: 90,
      justifyContent: "center",
      position: "absolute",
      right: 50,
      top: 15
    }]
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    style: {
      marginRight: handleDocumentAction ? 10 : 0
    },
    color: isItemActionable(item) ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.primary : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.disabled_color,
    icon: customActionIcon || mapIconWithStatus(item),
    size: 18
  })), actionButtons && handleDocumentSelection && /*#__PURE__*/React__default.createElement(DataTable.Cell, {
    onPress: event => {
      if (isItemEditable(item)) handleDocumentSelection({
        id: item === null || item === void 0 ? void 0 : item.id,
        type: item === null || item === void 0 ? void 0 : item.type,
        item,
        index
      });
    },
    style: [_styles.actionsCell, {
      flex: headers && (_headers5 = headers[(headers === null || headers === void 0 ? void 0 : headers.length) - 1]) !== null && _headers5 !== void 0 && _headers5.width ? (_headers6 = headers[(headers === null || headers === void 0 ? void 0 : headers.length) - 1]) === null || _headers6 === void 0 ? void 0 : _headers6.width : 1,
      flexBasis: 90,
      justifyContent: "center",
      position: "absolute",
      right: 10,
      top: 15
    }]
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    style: {
      marginRight: handleDocumentDeletion ? 10 : 0
    },
    color: isItemEditable(item) ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.primary : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.disabled_color,
    icon: customEditIcon || mapSelectionIconWithStatus(item) || AppAssets.icons.edit,
    size: 18
  })), actionButtons && handleDocumentDeletion && /*#__PURE__*/React__default.createElement(DataTable.Cell, {
    onPress: event => {
      if (isItemDeletable(item)) handleDocumentDeletion(item, index);
    },
    style: [_styles.actionsCell, {
      flex: headers && (_headers7 = headers[(headers === null || headers === void 0 ? void 0 : headers.length) - 1]) !== null && _headers7 !== void 0 && _headers7.width ? (_headers8 = headers[(headers === null || headers === void 0 ? void 0 : headers.length) - 1]) === null || _headers8 === void 0 ? void 0 : _headers8.width : 1,
      flexBasis: 90,
      justifyContent: "center",
      position: "absolute",
      right: -25,
      top: 15
    }]
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    style: {
      marginRight: handleDocumentDeletion ? 10 : 0
    },
    color: isItemDeletable(item) ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.red : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme11 = currentTheme.theme) === null || _currentTheme$theme11 === void 0 ? void 0 : _currentTheme$theme11.disabled_color,
    icon: customDeleteIcon || AppAssets.icons.delete,
    size: 18
  }))));
};
AppTableRow.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppTableRow"
};

const AppTable = _ref => {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _items$filter;
  let {
    headers,
    items,
    itemsPerPage = 20,
    marginRightBeforeActions = 60,
    style,
    showPagination,
    actionButtons = false,
    handleDocumentSelection,
    handleDocumentDeletion,
    handleDocumentAction,
    customEditIcon,
    customDeleteIcon,
    customActionIcon,
    actions,
    showDropDownMenuForActions = false,
    onActionItemPress = () => {},
    onClickMainAction = () => {},
    isItemDeletable = item => {
      return true;
    },
    isItemEditable = item => {
      return true;
    },
    isItemActionable = item => {
      return true;
    },
    mapIconWithStatus = item => {
      return AppAssets.icons.activeModel;
    },
    mapSelectionIconWithStatus = () => {
      return AppAssets.icons.edit;
    },
    actionButtonStyle,
    actionButtonMenuItemStyle,
    actionButtonWrapperStyles,
    mainActionLabel = "Edit"
  } = _ref;
  // Adapter: Convert legacy props to new pattern
  const hasLegacyActions = handleDocumentSelection || handleDocumentDeletion || handleDocumentAction;
  const adaptedActions = React__default.useMemo(() => {
    if (actions) return actions; // Use provided actions if available

    if (!hasLegacyActions) return undefined;
    const legacyActions = [];
    if (handleDocumentSelection) {
      legacyActions.push({
        label: "Edit",
        id: "EDIT",
        icon: customEditIcon || AppAssets.icons.edit
      });
    }
    if (handleDocumentAction) {
      legacyActions.push({
        label: "Action",
        id: "ACTION",
        icon: customActionIcon || AppAssets.icons.activeModel
      });
    }
    if (handleDocumentDeletion) {
      legacyActions.push({
        label: "Delete",
        id: "DELETE",
        icon: customDeleteIcon || AppAssets.icons.delete
      });
    }
    return legacyActions;
  }, [actions, handleDocumentSelection, handleDocumentDeletion, handleDocumentAction, customEditIcon, customDeleteIcon, customActionIcon]);
  const adaptedOnActionItemPress = React__default.useCallback((id, item, index) => {
    if (actions) {
      // Use provided onActionItemPress if actions are explicitly provided
      onActionItemPress(id, item, index);
      return;
    }

    // Handle legacy actions
    if (id === "EDIT" && handleDocumentSelection) {
      handleDocumentSelection({
        id: item === null || item === void 0 ? void 0 : item.id,
        type: item === null || item === void 0 ? void 0 : item.type,
        item,
        index
      });
    } else if (id === "ACTION" && handleDocumentAction) {
      handleDocumentAction({
        id: item === null || item === void 0 ? void 0 : item.id,
        type: item === null || item === void 0 ? void 0 : item.type,
        item,
        index
      });
    } else if (id === "DELETE" && handleDocumentDeletion) {
      handleDocumentDeletion(item, index);
    }
  }, [actions, onActionItemPress, handleDocumentSelection, handleDocumentAction, handleDocumentDeletion]);
  const adaptedOnClickMainAction = React__default.useCallback((item, index) => {
    if (actions) {
      // Use provided onClickMainAction if actions are explicitly provided
      onClickMainAction(item, index);
      return;
    }

    // Default to edit action for legacy mode
    if (handleDocumentSelection) {
      handleDocumentSelection({
        id: item === null || item === void 0 ? void 0 : item.id,
        type: item === null || item === void 0 ? void 0 : item.type,
        item,
        index
      });
    }
  }, [actions, onClickMainAction, handleDocumentSelection]);
  const shouldShowDropDownMenu = showDropDownMenuForActions || hasLegacyActions;
  const [page, setPage] = React__default.useState(0);
  const from = page * itemsPerPage;
  const to = (page + 1) * itemsPerPage;
  const {
    currentTheme
  } = useTheme();
  const _styles = styleGenerator(currentTheme);
  // #The theme is not applied anywhere
  const fontStyle = {
    fonts: {
      medium: "normalFont",
      light: "normalFont",
      thin: "normalFont",
      regular: "normalFont"
    },
    colors: {
      text: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.font_color,
      primary: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.primary,
      background: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.transparent
    }
  };
  return /*#__PURE__*/React__default.createElement(DataTable, {
    style: [_styles.table, style]
  }, /*#__PURE__*/React__default.createElement(DataTable.Header, {
    theme: fontStyle,
    style: _styles.header
  }, headers.map((h, index) => {
    var _headers$index, _headers$index2;
    return /*#__PURE__*/React__default.createElement(DataTable.Title, {
      style: [_styles.title, {
        flex: headers && (_headers$index = headers[index]) !== null && _headers$index !== void 0 && _headers$index.width ? (_headers$index2 = headers[index]) === null || _headers$index2 === void 0 ? void 0 : _headers$index2.width : 1,
        flexBasis: 70,
        position: index === (headers === null || headers === void 0 ? void 0 : headers.length) - 1 && actionButtons ? "absolute" : "unset",
        right: index === (headers === null || headers === void 0 ? void 0 : headers.length) - 1 && actionButtons ? 0 : "unset",
        marginRight: index === (headers === null || headers === void 0 ? void 0 : headers.length) - 2 && actionButtons ? marginRightBeforeActions : 0
      }],
      theme: fontStyle,
      numeric: h.isNumeric
    }, /*#__PURE__*/React__default.createElement(AppText, {
      wrapperStyle: {
        paddingHorizontal: 5
      },
      style: {
        fontWeight: "bold"
      }
    }, " ", h.title));
  })), items === null || items === void 0 ? void 0 : (_items$filter = items.filter(item => item)) === null || _items$filter === void 0 ? void 0 : _items$filter.map((item, index) => {
    return /*#__PURE__*/React__default.createElement(AppTableRow, {
      item: item,
      index: index,
      headers: headers,
      actionButtons: actionButtons,
      marginRightBeforeActions: marginRightBeforeActions,
      isItemActionable: isItemActionable,
      isItemDeletable: isItemDeletable,
      isItemEditable: isItemEditable,
      mapIconWithStatus: mapIconWithStatus,
      mapSelectionIconWithStatus: mapSelectionIconWithStatus,
      handleDocumentSelection: handleDocumentSelection,
      handleDocumentDeletion: handleDocumentDeletion,
      handleDocumentAction: handleDocumentAction,
      customEditIcon: customEditIcon,
      customDeleteIcon: customDeleteIcon,
      customActionIcon: customActionIcon,
      actions: adaptedActions,
      showDropDownMenuForActions: shouldShowDropDownMenu,
      onActionItemPress: adaptedOnActionItemPress,
      onClickMainAction: adaptedOnClickMainAction,
      actionButtonStyle: actionButtonStyle,
      actionButtonMenuItemStyle: actionButtonMenuItemStyle,
      actionButtonWrapperStyles: actionButtonWrapperStyles,
      currentTheme: currentTheme,
      mainActionLabel: mainActionLabel,
      _styles: _styles,
      fontStyle: fontStyle,
      key: index
    });
  }), showPagination && /*#__PURE__*/React__default.createElement(DataTable.Pagination, {
    style: _styles.pagination,
    theme: fontStyle,
    page: page,
    numberOfPages: Math.floor(items.length / itemsPerPage),
    onPageChange: page => {
      setPage(page);
    },
    label: "".concat(from + 1, "-").concat(to, " of ").concat(items.length)
  }));
};
const styleGenerator = props => {
  var _props$theme, _props$theme2, _props$theme3, _props$theme4, _props$theme5, _props$theme6, _props$theme7, _props$theme8, _props$theme9, _props$theme10, _props$theme11, _props$theme12;
  return StyleSheet.create({
    table: {
      fontFamily: "normalFont",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.small_font_size,
      color: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.font_color
    },
    pagination: {
      fontFamily: "normalFont",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.small_font_size,
      color: props === null || props === void 0 ? void 0 : (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.font_color
    },
    header: {
      fontFamily: "normalFont",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.medium_font_size,
      color: props === null || props === void 0 ? void 0 : (_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : _props$theme6.font_color
    },
    title: {
      fontFamily: "normalFont",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme7 = props.theme) === null || _props$theme7 === void 0 ? void 0 : _props$theme7.medium_font_size,
      color: props === null || props === void 0 ? void 0 : (_props$theme8 = props.theme) === null || _props$theme8 === void 0 ? void 0 : _props$theme8.font_color,
      display: "flex"
    },
    row: {
      fontFamily: "normalFont",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme9 = props.theme) === null || _props$theme9 === void 0 ? void 0 : _props$theme9.small_font_size,
      color: props === null || props === void 0 ? void 0 : (_props$theme10 = props.theme) === null || _props$theme10 === void 0 ? void 0 : _props$theme10.font_color,
      display: "flex",
      borderBottomWidth: 0.5
    },
    cell: {
      fontFamily: "normalFont",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme11 = props.theme) === null || _props$theme11 === void 0 ? void 0 : _props$theme11.small_font_size,
      color: props === null || props === void 0 ? void 0 : (_props$theme12 = props.theme) === null || _props$theme12 === void 0 ? void 0 : _props$theme12.font_color
    },
    actionsCell: {}
  });
};
AppTable.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppTable",
  "props": {
    "itemsPerPage": {
      "defaultValue": {
        "value": "20",
        "computed": false
      },
      "required": false
    },
    "marginRightBeforeActions": {
      "defaultValue": {
        "value": "60",
        "computed": false
      },
      "required": false
    },
    "actionButtons": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showDropDownMenuForActions": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "onActionItemPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onClickMainAction": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "isItemDeletable": {
      "defaultValue": {
        "value": "(item) => {\n  return true;\n}",
        "computed": false
      },
      "required": false
    },
    "isItemEditable": {
      "defaultValue": {
        "value": "(item) => {\n  return true;\n}",
        "computed": false
      },
      "required": false
    },
    "isItemActionable": {
      "defaultValue": {
        "value": "(item) => {\n  return true;\n}",
        "computed": false
      },
      "required": false
    },
    "mapIconWithStatus": {
      "defaultValue": {
        "value": "(item) => {\n  return Assets.icons.activeModel;\n}",
        "computed": false
      },
      "required": false
    },
    "mapSelectionIconWithStatus": {
      "defaultValue": {
        "value": "() => {\n  return Assets.icons.edit;\n}",
        "computed": false
      },
      "required": false
    },
    "mainActionLabel": {
      "defaultValue": {
        "value": "\"Edit\"",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppTable as default };
